export type AdaptiveContentTargetObjectType =
    | 'section'
    | 'section-group'
    | 'variant'
    | 'page'
    | 'header-link'
    | 'external-link'
    | 'mcp-server';

export function getTextForTarget(target: AdaptiveContentTargetObjectType) {
    switch (target) {
        case 'section-group':
            return 'section group';
        case 'header-link':
            return 'header item';
        case 'external-link':
            return 'external link';
        case 'mcp-server':
            return 'MCP server';
        default:
            return target;
    }
}
